"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlagContext = exports.useExperimentsContext = exports.MetricaExperimentsProvider = exports.MetricaExperimentsContext = void 0;
const react_1 = __importStar(require("react"));
const useExperiments_1 = require("./useExperiments");
exports.MetricaExperimentsContext = react_1.default.createContext({
    flags: {},
    ready: false,
});
const DEFAULT_ANTIFLICKER_TIMEOUT = 4000;
const MetricaExperimentsProvider = (props) => {
    const { children, enableAntiflicker, antiflickerTimeout = DEFAULT_ANTIFLICKER_TIMEOUT } = props, params = __rest(props, ["children", "enableAntiflicker", "antiflickerTimeout"]);
    const [hidden, setHidden] = (0, react_1.useState)(enableAntiflicker);
    const data = (0, useExperiments_1.useExperiments)(params);
    const ready = data.ready;
    (0, react_1.useEffect)(() => {
        if (!hidden) {
            return;
        }
        if (ready) {
            setHidden(false);
            return;
        }
        const timer = setTimeout(() => setHidden(false), antiflickerTimeout);
        return () => clearTimeout(timer);
    }, [ready]);
    if (hidden) {
        return null;
    }
    return (react_1.default.createElement(exports.MetricaExperimentsContext.Provider, { value: data }, children));
};
exports.MetricaExperimentsProvider = MetricaExperimentsProvider;
const useExperimentsContext = () => (0, react_1.useContext)(exports.MetricaExperimentsContext);
exports.useExperimentsContext = useExperimentsContext;
function useFlagContext(name, takeFirst = false) {
    const { ready, flags } = (0, exports.useExperimentsContext)();
    const value = flags[name] || [];
    return {
        value: takeFirst ? (value[0] || '') : value,
        ready,
    };
}
exports.useFlagContext = useFlagContext;
;
